<template>
    <div class="content">
        <div class="header flex wrap center">
            <Header></Header>
        </div>
        <div class="body flex wrap center">
            <div class="row">
                <section class="overview flex wrap center">
                    <div class="right">
                        <h1>{{ entity?.title }}</h1>
                        <p>{{ entity?.extra_description }}</p>
                        <div v-if="entity?.category" class="category flex wrap start vcenter">
                            <span>{{ entity?.category }}</span>
                        </div>
                        <div class="metas flex wrap center vcenter">
                            <div class="flex wrap space vcenter">
                                <div class="flex center">
                                    <i class="fe fe-16 fe-calendar"></i>
                                    <span>{{ data?.publish_at || '1403/01/01' }}</span>
                                </div>
                                <div class="flex center">
                                    <i class="fe fe-16 fe-message-circle"></i>
                                    <span>{{ data?.comments || 0 }}</span>
                                </div>
                                <div class="flex center">
                                    <i class="fe fe-16 fe-eye"></i>
                                    <span>{{ data?.views || 0 }}</span>
                                </div>
                                <div class="flex center">
                                    <i class="fe fe-16 fe-star"></i>
                                    <span>{{ data?.rates || 0 }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="left">
                        <img v-lazy="this.data['image'] || '/images/projectbanner.webp'" :alt="'دانشنامه آتیاکراد'"
                            loading="lazy" />
                        <img class="mobile" v-lazy="this.data['image'] || '/images/projectoverviewbanner.webp'"
                            :alt="'دانشنامه آتیاکراد'" loading="lazy" />
                    </div>
                </section>
                <section class="main flex wrap center">
                    <section>
                        <div class="ql-editor" v-html="entity?.description"></div>
                    </section>
                    <aside class="sidebar">
                        <div class="newsletter">
                            <div class="head">
                                <div class="title">
                                    <h1>برای سرمایه گذاری‌های جدید خبرم کن</h1>
                                </div>
                            </div>
                            <Newsletter :title="false"></Newsletter>
                        </div>
                    </aside>
                </section>
                <section class="footer"></section>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
/* eslint-disable */
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import Newsletter from '../components/Newsletter.vue'

import '@vueup/vue-quill/dist/vue-quill.snow.css'

export default {
    name: 'Post',
    props: ['id'],
    inject: ['base'],
    components: { Header, Newsletter, Footer },
    created() {
        this.$emit('onloading', true)
        this.base.API().get(`Advertisement/Post/GetPostByUID?uid=${this.id}`
            , (response) => {
                if (this.base.Util().success(response)) {
                    this.entity = response.data.data[0]
                    // this.data = response.data.data[this.entity?.id]

                    this.base.API().getAsArrayBuffer(`Advertisement/Post/Download?uid=${this.entity?.id}&key=${window.screen.width <= 540 ? 'image' : 'banner'}`
                        , (response) => {
                            try {
                                const decoder = new TextDecoder('utf-8')
                                const json = decoder.decode(response.data)
                                JSON.parse(json)
                            } catch (e) {
                                this.data['image'] = `data:image/webp;base64,${btoa(String.fromCharCode(...new Uint8Array(response.data)))}`
                            }
                        }, (error) => {

                        })
                }
                this.$emit('onloading', false)
            }, (error) => {
                this.$emit('onloading', false)
            })
    },
    data() {
        return {
            entity: {},
            data: {},
            models: {}
        }
    }
}
</script>

<style scoped src="../assets/css/views/post.css"></style>
<style src="../../node_modules/quill/dist/quill.core.css"></style>
<style src="../../node_modules/quill/dist/quill.snow.css"></style>